const demo_video_cards_listing = (function() {
    'use strict';
    const Params = {
        'debug': false,
    };
    const DOM = {};
    const Methods = {
        console(msg, showPrefix=true) {
            if (msg && Params.debug) { 
                if (showPrefix != false) { msg = 'DV cards listing: '+ msg }
                console.log(msg) 
            }
        },
        reset_menu_items(value) {
            if (typeof value == 'undefined' || !value) { return; }
            value = seismicUtilities.scrub(value);
            if ( value == '' ) { return; }
            for (let i=0, len=DOM.menu_items.length; i<len; i++) {
                const status = ( value == DOM.menu_items[i].getAttribute('data-value') ) ? 'true' : 'false',
                    tabindex = ( status == 'false' ) ? '0' : '-1';
                DOM.menu_items[i].setAttribute('aria-checked', status);
                DOM.menu_items[i].setAttribute('tabindex', tabindex);
            }
        },
        sections_display(value) {
            if (typeof value == 'undefined' || !value) { return; }
            value = seismicUtilities.scrub(value);
            if ( value == '' ) { return; }
            const show_all = (value == 'all'); 
            for (let i=0, len = DOM.sections.length; i<len; i++) {
                const status = !( show_all == true || value == DOM.sections[i].getAttribute('data-category') ),
                    tabindex = ( status == true ) ? '-1' : '0';
                DOM.sections[i].setAttribute('aria-hidden', status);
                DOM.sections[i].setAttribute('tabindex', tabindex);
            }
        },
        get_section_height(elem) {
            if ( typeof elem == 'undefined' || !(elem instanceof HTMLElement) ) { return false; }
            return elem.getBoundingClientRect().height +'px';
        },
        set_all_sections_max_height() {
            for (let i=0, len = DOM.sections.length; i<len; i++) {
                const val = this.get_section_height(DOM.sections[i]);
                if (val) { DOM.sections[i].style.setProperty('--max-height', val) }
            }
        },
        register_category_values() {
            if (typeof Params.section_names == 'undefined') { Params.categories = []; }
            Params.categories.push('all');
            for (let i=0, len = DOM.sections.length; i<len; i++) {
                Params.categories.push( seismicUtilities.scrub( DOM.sections[i].getAttribute('data-category') ) );
            }
            this.console('Category section values registered:');
            this.console(Params.categories);
        },
        scroll_to_menu() {
            if (Params.menu_id) {
                setTimeout(() => {
                    document.querySelector('#'+ Params.menu_id).scrollIntoView({ behavior: 'smooth', block: 'start' })
                }, 300)    
            }
        },
        manage_history(action='push', param=false) {
            const qs_param = '_demo_videos_categories';
            if (action == 'push' && param != false) {
                param = seismicUtilities.scrub(param);
                if ( !Params.categories.includes(param) ) { 
                    this.console('manage_history - '+ param +' not found in registered categories');
                    return; 
                }
                const url = new URL(window.location);
                url.searchParams.set(qs_param, param);
                window.history.pushState({}, '', url);
            } else if (action == 'check') {
                const url_qs = new URLSearchParams(window.location.search);
                if ( url_qs.has(qs_param) ) {
                    const value = seismicUtilities.scrub( url_qs.get(qs_param) );
                    if (value != '' && Params.categories.includes(value)) {
                        this.activate_view(value);
                    } else {
                        this.console('Invalid query string value.');
                    }
                }
            }
        },
        click_event(elem) {
            if ( typeof elem == 'undefined' || !(elem instanceof HTMLElement) ) { return false; }
            const checked = elem.getAttribute('aria-checked'),
                value = elem.getAttribute('data-value');
            if (checked == 'true') {  return; }
            this.activate_view(value);
        },
        activate_view(value) {
            if (typeof value == 'undefined' || value == '') { let value = 'all'; }
            if (!Params.categories.includes(value)) { this.console('Requested section not found.'); return; }
            this.reset_menu_items(value);
            this.sections_display(value);
            this.manage_history('push', value);
            this.scroll_to_menu();
        },
        init() {
            DOM.menu = document.querySelector('.pill-menu');
            if (!DOM.menu) { return false; }
            DOM.menu_items = DOM.menu.querySelectorAll('[role="radio"]');
            DOM.sections = document.querySelectorAll('.category-section');
            if (!DOM.menu_items.length || !DOM.sections.length) { return false; }
            
            Params.menu_id = DOM.menu.closest('div.pill-menu').getAttribute('id');
            if (!Params.menu_id) {
                Params.menu_id = seismicUtilities.makeId();
                DOM.menu.closest('div.pill-menu').setAttribute('id', Params.menu_id);
            }

            this.register_category_values();

            // set_all_sections_max_height - Needed only if doing show/hide with opacity:
            // this.set_all_sections_max_height();

            for (let i=0, len=DOM.menu_items.length; i<len; i++) {
                DOM.menu_items[i].addEventListener('click', (event)=>{
                    demo_video_cards_listing.click_event(event.currentTarget);
                });
                DOM.menu_items[i].addEventListener('keyup', (event)=>{
                    if ( event.code == 'Enter' ) {
                        demo_video_cards_listing.click_event(event.currentTarget);
                    }
                });
                DOM.menu_items[i].addEventListener('keydown', (event)=>{
                    if  ( event.code == 'Space' ) {
                        event.preventDefault();
                        demo_video_cards_listing.click_event(event.currentTarget);
                    }
                });

            }
            window.addEventListener('popstate', (event)=>{
                demo_video_cards_listing.manage_history('check');
            });

            this.manage_history('check');
        }
    };
    return Methods;
})();
document.addEventListener('DOMContentLoaded', ()=>{demo_video_cards_listing.init()} );
